import React, { useEffect, useState } from 'react';
import { useListadoRecordado } from '../../components/useListadoRecordado';
import axios from '../../axiosConfig';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Modal } from 'react-bootstrap';
import { useLoading } from '../../components/LoadingContext';
// import './ShowDatos.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationTable from '../../components/PaginationTable';  // Importa el componente de paginación
import GraficaBarras from '../../components/GraficaBarras';
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, LabelList } from 'recharts';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { FaUserFriends, FaClock, FaBook,FaSync,FaSearch  } from 'react-icons/fa';  // Importamos íconos de react-icons
import ProgressBar from 'react-bootstrap/ProgressBar';
import { FaExpand, FaCompress } from 'react-icons/fa'; // Íconos para expandir/contraer
import { motion } from 'framer-motion';
import estadosMunicipios from '../../components/estadosMunicipios.json';

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28'];

// Un color por cada uno de los 7 rangos de edad oficiales.
const COLORS_EDAD = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28', '#e8743b'];


const ShowIndicadores = () => {
    const [datos, setDatos] = useState([]);

    const itemsPerPage = 8;
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
    const [statistics, setStatistics] = useState({});
    // Mueve esto al principio del componente

    const [nivelInstruccionOptions, setNivelInstruccionOptions] = useState([]);
    const [generoOptions, setGeneroOptions] = useState([]);
    const [estadoOptions, setEstadoOptions] = useState([]);
    const [periodoOptions, setPeriodoOptions] = useState([]);
    const [areaOptions, setAreaOptions] = useState([]);
    const [cohorteOptions, setCohorteOptions] = useState([]);
    const [patrocinanteOptions, setPatrocinanteOptions] = useState([]);
    const [procedenciaOptions, setProcedenciaOptions] = useState([]);
    const [centroOptions, setCentroOptions] = useState([]);
    const [grupoOptions, setGrupoOptions] = useState([]);
    const [grupoPrioritarioOptions, setGrupoPrioritarioOptions] = useState([]);
    const [unidadOptions, setUnidadOptions] = useState([]);
    const [inscritosAporte, setInscritosAporte] = useState(0);
    const [inscritosPatrocinados, setInscritosPatrocinados] = useState(0);
    const [cursosPorArea, setCursosPorArea] = useState([]);
    const [inscritosPorStatusPay, setInscritosPorStatusPay] = useState({});
    const [inscritosPorStatusCurso, setInscritosPorStatusCurso] = useState({});


    const totalParticipantes = statistics?.totalInscritos    || 0;
    const mayorEdad = statistics?.mayorEdad || 0;
    const menorEdad = statistics?.menorEdad || 0;
    const promedioEdad = statistics?.promedioEdad || 0;
    const porcentajeMasculino = statistics?.porcentajesGenero?.masculino || 0;
    const porcentajeFemenino = statistics?.porcentajesGenero?.femenino || 0;
    const porcentajeOtros = statistics?.porcentajesGenero?.otros || 0;
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [mostrarSoloTabla, setMostrarSoloTabla] = useState(true);
      const [municipiosDisponibles, setMunicipiosDisponibles] = useState([]);  // Municipios que se mostrarán según el estado seleccionado
    
                  
     const toggleTablaExpandida = () => {
        if (mostrarSoloTabla == true){
            getAllIndicadores();
        }
        setMostrarSoloTabla(prevState => !prevState);
        
    };
    const isActiveFilterValue = (v) => {
  if (v === null || v === undefined) return false;
  return String(v).trim() !== "";
};

 const activeFilterClass = (v) => (isActiveFilterValue(v) ? "is-active-filter" : "");

    // Página y filtros se recuerdan: al volver de Editar el listado queda donde estaba.
    const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado('indicadores', {
        nivel_instruccion_id: '',
        genero_id: '',
        centro_id: '',
        area_id: '',
        periodo_id: '',
        estado_id: '',
        unidad_id: '',
        cohorte: '',
        cedula_identidad: '' ,
        status_pay:'',
        status_curso:'',
        es_patrocinado:'',
        patrocinante_id:'',
        patrocinante_id2:'',
        patrocinante_id3:'',
        fecha_inscripcion:'',
        fecha_mayor:'',
        fecha_menor:'',
        procedencia_id:'',
        nivel_instruccion_id:'',
        estado_id:'',
        nombres:'',
        apellidos:'',
        tlf:'',
        centro_id:'',
        grupo:'',
        externo:'',
        edad_mayor:'',
        edad_menor:'',
        nombre_uc:'',
        cod_uc:'',
        municipio:'',
        grupo_prioritario_id:'',

    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    
    const { setLoading } = useLoading();
    const [error, setError] = useState(null);
    const navigate = useNavigate();

   const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
};


    // Obtener el rol del usuario desde localStorage
    const userRole = localStorage.getItem('role'); // Puede ser 'admin', 'superuser', 'invitado', etc.
  
 
    useEffect(() => {
        setLoading(true);
        getIndicadores(currentPage);
        fetchFilterOptions()
            .finally(() => setLoading(false));
    }, []); 

    
    
    
    
    const handlePageChange = (page) => {
        setCurrentPage(page);
        getIndicadores(page); // Llama a `getAllIndicadores` con el nuevo número de página
        
    };

     
      const handleEstadoChange = (e) => {
        const estadoId = e.target.value;
        
        // Encuentra el estado seleccionado en el JSON
        const estadoSeleccionado = estadosMunicipios.find(estado => estado.id_estado === parseInt(estadoId));
        
        // Actualiza los municipios disponibles
        setMunicipiosDisponibles(estadoSeleccionado ? estadoSeleccionado.municipios : []);
        
        // Actualiza el estado seleccionado en formData
        setFilters({
          ...filters,
          estado_id: estadoId,
          municipio: ''  // Reseteamos el municipio al cambiar de estado
        });
      };

    const getAllIndicadores = async (page = 1) => {
        // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
        // un número es la página 1. Y la página mostrada se fija aquí, así
        // coincide siempre con los datos (buscar, recargar, borrar, paginar).
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
         setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/indicadores-filtrados`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina }, // Incluye `page` en los parámetros
            });
            
            const estadisticas = response.data.estadisticas || {};
            estadisticas.rangoEdades = estadisticas.rangoEdades || [];
            
            setDatos(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setStatistics(estadisticas);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
            setInscritosAporte(estadisticas.inscritosAporte || 0);
          setInscritosPatrocinados(estadisticas.inscritosPatrocinados || 0);
          setCursosPorArea(estadisticas.cursosPorArea || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setDatos([]);
            setStatistics({ rangoEdades: [] });
        }
    };

    const getIndicadores = async (page = 1) => {
        // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
        // un número es la página 1. Y la página mostrada se fija aquí, así
        // coincide siempre con los datos (buscar, recargar, borrar, paginar).
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/indicadores-solos`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina }, // Incluye `page` en los parámetros
            });
            
         
            
            setDatos(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
          
  
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setDatos([]);
            setStatistics({ rangoEdades: [] });
        }
    };


    const fetchFilterOptions = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/filter-indicadores`, { headers: { Authorization: `Bearer ${token}` } });
            
            setNivelInstruccionOptions(response.data.nivelInstruccion);
            setGeneroOptions(response.data.genero);
            setEstadoOptions(response.data.estado);
            setPeriodoOptions(response.data.periodo);
            setCohorteOptions(response.data.cohorte);
            setCentroOptions(response.data.centro);
            setAreaOptions(response.data.area);
            setUnidadOptions(response.data.unidad);
            setPatrocinanteOptions(response.data.patrocinante);
            setProcedenciaOptions(response.data.procedencia);
            setGrupoOptions(response.data.grupo);
            setGrupoPrioritarioOptions(response.data.grupo_prioritario);

        } catch (error) {
            setError('Error fetching filter options');
            console.error('Error fetching filter options:', error);
        }
    };



    const loadData = async () => {
        setLoadingData(true); // Inicia el estado de carga
        try {

        if (mostrarSoloTabla == true){
            getIndicadores();
            fetchFilterOptions();
        }
        else {getAllIndicadores();
            fetchFilterOptions()};
            
            
        } catch (error) {
            console.error('Error recargando los datos:', error); // Maneja el error si ocurre
        } finally {
            setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
        }
    };

    const printInfo = async (filters) => {
        try {
          const token = localStorage.getItem("token");
          if (!token) {
            alert("Token no encontrado.");
            return;
          }
      
          // Realizar la solicitud GET a la ruta que genera los datos en JSON
          const response = await axios.get(`/indicadores-print`, {
            headers: { Authorization: `Bearer ${token}` },
            params: filters, // Pasamos los filtros a la ruta
          });
      
          // Extraer los datos principales y las estadísticas
          const jsonData = response.data.datos; // Clave 'datos'
          const estadisticasData = response.data.estadisticas; // Clave 'estadisticas'
      
          if (!jsonData || jsonData.length === 0) {
            alert("No hay datos para exportar.");
            return;
          }
      
          // Convertir los datos principales a una hoja
          const worksheet1 = XLSX.utils.json_to_sheet(jsonData); // Hoja de datos
          const workbook = XLSX.utils.book_new(); // Crea un libro nuevo
          XLSX.utils.book_append_sheet(workbook, worksheet1, "Datos"); // Añade la hoja al libro
      // Preparar las estadísticas para convertirlas
        const estadisticasArray = [];

        // Iterar sobre las estadísticas y descomponerlas
        Object.entries(estadisticasData).forEach(([key, value]) => {
        if (typeof value === "object" && !Array.isArray(value)) {
            // Si el valor es un objeto, descomponer sus datos (por ejemplo, participantesPorEstado, nivelesInstruccion)
            Object.entries(value).forEach(([subKey, subValue]) => {
            if (typeof subValue === "object") {
                estadisticasArray.push({
                Estadística: `${key} - ${subKey}`,
                Cantidad: subValue.count || 0,
                Porcentaje: subValue.percentage ? `${subValue.percentage.toFixed(2)}%` : "0%",
                });
            } else {
                estadisticasArray.push({
                Estadística: `${key} - ${subKey}`,
                Valor: subValue,
                });
            }
            });
        } else {
            // Si es un valor simple, agregarlo directamente
            estadisticasArray.push({
            Estadística: key,
            Valor: value,
            });
        }
        });

        // Convertir las estadísticas a una hoja
        const worksheet2 = XLSX.utils.json_to_sheet(estadisticasArray);
        XLSX.utils.book_append_sheet(workbook, worksheet2, "Estadísticas"); // Añade la segunda hoja
                // Generar el archivo Excel
                const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            
                // Crear un Blob y guardarlo como archivo
                const blob = new Blob([excelBuffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "calculo_indicadores.xlsx");
                } catch (error) {
                console.error("Error al generar el archivo Excel", error);
                alert("Hubo un error al generar el archivo Excel");
                }
            };
 
      

      const handlePrint = async () => {
        setShowModalInfo(false); // Cerrar el modal
        await printInfo(filters); // Llamar a la función de impresión con los filtros
      };
    



    
    const rangoEdades = statistics?.rangoEdades
    ? Object.entries(statistics.rangoEdades).map(([name, percentage]) => ({
        name,
        value: percentage,
    }))
    : [];


    const comoEnteroSuperatecData = statistics?.comoEnteroSuperatec
    ? Object.entries(statistics.comoEnteroSuperatec).map(([name, obj]) => ({
        name,
        value: obj.percentage,
    }))
    : [];

const grupoPrioritarioData = statistics?.grupoPrioritario
    ? Object.entries(statistics.grupoPrioritario).map(([name, obj]) => ({
        name,
        value: obj.percentage,
    }))
    : [];



    const nivelesInstruccionData = statistics?.nivelesInstruccion
    ? Object.entries(statistics.nivelesInstruccion).map(([name, obj]) => ({
        name,
        count: obj.count,
    }))
    : [];

const participantesPorEstadoData = statistics?.participantesPorEstado
    ? Object.entries(statistics.participantesPorEstado).map(([name, obj]) => ({
        name,
        count: obj.count,
    }))
    : [];

    const participantsByAportePatrocinado = [
        { name: 'Realiza Aporte', value: inscritosAporte },
        { name: 'Es Patrocinado', value: inscritosPatrocinados },
      ];

      const AreaGraphic = Object.entries(cursosPorArea).map(([name, data]) => ({
        name,
        value: data.count, // Usar 'count' en lugar de 'value' directamente
        percentage: data.percentage.toFixed(2) + "%", // Formatear porcentaje con 2 decimales
      }));


      const estadoPago = statistics?.estadoPagos?.map(({ nombre, cantidad }) => {
        let color;
      
        if (nombre === "No pagado (Rojo)") color = "red"; // Naranja
        if (nombre === "En proceso (Naranja)") color = "#FFA500"; // Verde
        if (nombre === "Pagado (Verde)") color = "green"; // Rojo
        if (nombre === "Patrocinado (Azul)") color = "blue"; // Rojo
        if (nombre === "Exonerado (Rosado)") color = "#fc53c4"; // Rojo
        
       
        return{
        name: nombre,
        value: cantidad, // Clave que PieChart espera para los valores numéricos
        color
        };
      });
      
      const estadoCurso = statistics?.estadoCursos?.map(({ nombre, cantidad }) => {
        let color;
        if (nombre === "Inscrito" || nombre === "No finalizado") color = "#FFA500"; // Naranja
        if (nombre === "Egresado/Certificado") color = "green"; // Verde
        if (nombre === "Retirado") color = "#FF0000"; // Rojo
      
        return {
          name: nombre,
          value: cantidad,
          color,
        };
      });

        const renderStatusPayDot = (status_pay) => {
    const color = getStatusPayColor(status_pay);
    return (
      <div
        style={{
          height: '20px',
          width: '20px',
          borderRadius: '50%',
          backgroundColor: color,
          display: 'inline-block',
        }}
      ></div>
    );
  };

  const renderStatusCursoTriangle = (status_curso) => {
  const color = getStatusCursoColor(status_curso); // Usar la función correcta para el color
  return (
    <div
      style={{
        width: 10,
        height: 10,
        borderLeft: '6px solid transparent',    // Lado izquierdo del triángulo
        borderRight: '6px solid transparent',   // Lado derecho del triángulo
        borderBottom: `10px solid ${color}`,    // Base del triángulo, define el color
        display: 'inline-block',
        marginRight: '5px',
      }}
    ></div>
  );
};


  const getStatusPayColor = (status_pay) => {
    if (status_pay === '1') return 'red'; // No pagado
    if (status_pay === '2') return 'orange'; // En proceso
    if (status_pay === '3') return 'green'; // Pagado
    if (status_pay === '4') return 'blue'; // Culminado
    if (status_pay === '5') return '#fc53c4'; // Rosa claro en hexadecimal

    return 'gray'; // Desconocido
  };

  const getStatusCursoColor = (status_curso) => {
    if (status_curso === '1') return 'orange'; // Inscrito
    if (status_curso === '2') return 'green'; // Egresado/Certificado
    if (status_curso === '3') return 'red'; // Retirado
    return 'gray'; // Desconocido
};


      
      

    const columns = ["Status Curso","Status Pago","Cédula", "Nombres", "Apellidos","Edad","Género","Cod Unidad C.","Unidad Curricular","Centro","Cohorte","Periodo","Grupo","Fecha Insc", "Email", "Teléfono","Procedencia","Estado","Es Patrocinado","Patrocinante 1"];

    const renderItem = (dato) => (
        <tr key={dato.id}>
            <td className="text-center">{renderStatusCursoTriangle(dato.status_curso)}</td>
            <td className="text-center">{renderStatusPayDot(dato.status_pay)}</td>
             
            <td className="col">{dato?.datos_identificacion?.cedula_identidad}</td>
            <td className="col">{dato?.datos_identificacion?.nombres}</td>
            <td className="col">{dato?.datos_identificacion?.apellidos}</td>
            <td className="col">{dato?.edad}</td>
            <td className="col">{dato?.datos_identificacion?.genero?.descripcion}</td>
            <td className="col">{dato?.curso?.cod}</td>
            <td className="col">{dato?.curso?.descripcion}</td>
            <td className="col">{dato?.centro?.descripcion}</td>
            <td className="col">{dato?.cohorte}</td>
            <td className="col">{dato?.periodo?.descripcion}</td>
            <td className="col">{dato?.grupo}</td>
           <td className="col">
            {(dato?.fecha_inscripcion ?? '').toString().split(/[T\s]/)[0]}
            </td>

            <td className="col">{dato?.datos_identificacion?.direccion_email}</td>
            <td className="col">{dato?.datos_identificacion?.telefono_celular}</td>
            <td className="col">{dato?.datos_identificacion?.procedencia?.descripcion}</td>
            <td className="col">{dato?.datos_identificacion?.estado?.descripcion}</td>
            <td className="col">{dato?.es_patrocinado ? "Sí" : "No"}</td>
            <td className="col">{dato?.patrocinante1?.nombre_patrocinante}</td>
            

          
        </tr>
    );
    
    

    return (
        <div className="container-fluid " style={{ fontSize: '0.85rem' }}>
             <motion.div 
                initial={{ opacity: 1, maxHeight: "500px" }} // Establece una altura máxima inicial
                animate={{
                    opacity: mostrarSoloTabla ? 0 : 1,
                    maxHeight: mostrarSoloTabla ? 0 : "500px", // Reduce la altura en transición
                }}
                transition={{ duration: 0.5, ease: "easeInOut" }} // Animación más fluida
                style={{ overflow: "hidden" }} // Evita que los elementos internos se muestren fuera de la caja
            >
            <div className="stat-box d-flex justify-content-between" style={{ maxWidth: '100%' }}> 
                {/* Total de Participantes */}
                <div className="stat-card" style={{ padding: '5px', margin: '0 10px', width: '22%' }}>
                    <div className="stat-icon"><FaUserFriends /></div>
                    <div className="stat-number" style={{ color: '#58c765', fontSize: '1.8rem' }}>{totalParticipantes}</div>
                    <h4 style={{ fontSize: '1.1rem', color:'gray' }}>Total Inscripciones</h4>
                </div>
                <div className="stat-card" style={{
                    padding: '8px',
                    margin: '0 10px',
                    width: '22%',
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                }}>

                    {/* Menor y Mayor Edad - Distribuidos a los lados */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',  // Distribuye menor a la izquierda y mayor a la derecha
                        fontSize: '0.8rem',  // Ajustamos el tamaño del texto
                        color: '#6c757d',
                        padding: '0 8px',  // Reducimos el padding para que esté más junto
                    }}>
                        <div style={{ color: '#5cb85c', fontWeight: 'bold' }}> {/* Color verde para menor */}
                            <span>↓ Menor:</span> {menorEdad} años
                        </div>
                        <div style={{ color: '#d9534f', fontWeight: 'bold' }}> {/* Color rojo para mayor */}
                            <span>↑ Mayor:</span> {mayorEdad} años
                        </div>
                    </div>

                    {/* Promedio de Edad */}
                    <div className="stat-number" style={{
                        color: '#ffda1f',  
                        fontSize: '1.7rem',  // Reducimos el tamaño de la fuente
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: '3px',  // Reducimos el margen
                    }}>
                        {promedioEdad.toFixed(0)} Años
                    </div>

                    <h4 style={{
                        fontSize: '0.9rem',  // Reducimos el tamaño del texto
                        color: '#6c757d',  
                        textAlign: 'center',
                        marginBottom: '6px',  // Reducimos el margen inferior
                    }}>
                        Promedio de Edad
                    </h4>

                    {/* Barra de Progreso */}
                    <div style={{ width: '75%', margin: '0 auto' }}>
                        <ProgressBar
                            now={(promedioEdad * 100) /mayorEdad} 
                            variant="warning"
                            style={{
                                height: '8px',  // Reducimos la altura de la barra
                                borderRadius: '5px',
                                backgroundColor: '#f1f1f1'
                            }}
                        />
                    </div>
                   
                </div>



                
                <div className="stat-card" style={{ padding: '0', margin: '0 10px', width: '100%', maxWidth: '300px' }}> 
                    <ResponsiveContainer width="100%" height={120}> {/* Ajustamos el width y height dinámicamente */}
                        <PieChart>
                        <Pie
                            data={[
                            { name: 'Masculino', value: porcentajeMasculino },
                            { name: 'Femenino', value: porcentajeFemenino },
                            ]}
                            dataKey="value"
                            startAngle={180} // Semicírculo
                            endAngle={0}
                            cx="50%"        // Centrar horizontalmente con porcentaje
                            cy="70%"        // Ajustamos la gráfica para pegarla más arriba
                            outerRadius="70%" // Radio basado en el porcentaje del contenedor para mayor flexibilidad
                            fill="#8884d8"
                            label={({ name, value }) => ` ${value.toFixed(2)}%`} // Mostrar los porcentajes
                            labelLine={true}
                        >
                            {/* Colores para cada sector */}
                            <Cell key="Masculino" fill="#185da7" />
                            <Cell key="Femenino" fill="rgba(254, 185, 56, 0.9)" />
                        </Pie>
                        <Legend 
                            layout="horizontal" 
                            verticalAlign="bottom" 
                            align="center" 
                            wrapperStyle={{ 
                            width: "88%", 
                            textAlign: "center", 
                            marginTop: "-15px", 
                            fontSize: '10px' 
                            }}
                        />
                        <Tooltip />
                        </PieChart>
                    </ResponsiveContainer>
                    </div>



                {/* Promedio de Aporte y Patrocinado */}
                <div className="stat-card" style={{ padding: '5px', margin: '0 10px', width: '22%' }}> {/* Reducir el ancho a 22% */}
                              <ResponsiveContainer width="100%" height={120}>
                                <PieChart>
                                  <Pie
                                    data={participantsByAportePatrocinado}
                                    dataKey="value"
                                    startAngle={180}
                                    endAngle={0}
                                    cx="50%"
                                    cy="70%"
                                    outerRadius="70%"
                                    fill="#8884d8"
                                    label={({ name, value }) => ` ${value} ${name}`}
                                    labelLine={true}
                                  >
                                    <Cell key="RealizaAporte" fill="#8884d8" />
                                    <Cell key="EsPatrocinado" fill="#82ca9d" />
                                  </Pie>
                                 
                                  <Tooltip />
                                </PieChart>
                              </ResponsiveContainer>
                    
                            </div>

                

            </div>

            </motion.div>

            <div className="row" style={{ marginTop: '10px' }}>
                {/* Columna para la tabla */}
                <div className="col-lg-12"> {/* Ajustado para más espacio a la tabla */}
                    <div className="card-box" style={{ padding: '10px' }}> {/* Reduce padding de la tabla */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2 style={{ fontSize: '1.8rem' }}>Cálculo de Indicadores</h2>
                            <div className="d-flex align-items-center">
                                <Button 
                                    variant="info me-2" 
                                    onClick={toggleTablaExpandida} 
                                    style={{ padding: '5px 15px' }}
                                    title={mostrarSoloTabla ? "Mostrar Todo" : "Modo Tabla Expandida"}
                                >
                                    {mostrarSoloTabla ? <FaCompress /> : <FaExpand />}
                                </Button>
                           
                                    <Button
                                    variant="info me-2"
                                    onClick={loadData}
                                    disabled={loadingData} // Deshabilita el botón si está cargando
                                    style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                    title="Recargar datos"
                                >
                                    

                                    {/* Icono de recarga */}
                                    {loadingData ? (
                                    <FaSync className="spin" /> // Ícono girando si está cargando
                                    ) : (
                                    <FaSync />
                                    )}
                                </Button>

                               <Button 
                                        variant="info me-2" 
                                        onClick={() => {
                                            if (mostrarSoloTabla === false) {
                                                getAllIndicadores();
                                            } else {
                                                getIndicadores();
                                            }
                                        }}
                                        style={{ padding: '5px 10px', width: '120px' }} 
                                        title="Buscar"
                                    >
                                        <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                    </Button>
                                <Button
                                    variant="btn btn-info"
                                    onClick={() => setShowModalInfo(true)} // Abrir el modal
                                    className="me-2"
                                    title="Exportar en Excel"
                                >
                                    <i className="bi bi-printer-fill"></i> {/* Icono de impresora */}
                                </Button>

                              
                        </div>
                    </div>

                        {/* Filtros */}
                        <div className="d-flex gap-2 align-items-center mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Buscar por Cédula"
                                value={filters.cedula_identidad} // Conecta el campo de cédula al estado de filtros
                                name="cedula_identidad"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.cedula_identidad)}
                            />

                            <Form.Control
                                type="text"
                                placeholder="Buscar por Nombre"
                                value={filters.nombres} // Conecta el campo de cédula al estado de filtros
                                name="nombres"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.nombres)}
                            />
                            <Form.Control
                                type="text"
                                placeholder="Buscar por Apellido"
                                value={filters.apellidos} // Conecta el campo de cédula al estado de filtros
                                name="apellidos"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.apellidos)}
                            />
                            </div>
                            <div className="d-flex gap-2 align-items-center mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Buscar por Nombre de Programa"
                                value={filters.nombre_uc} // Conecta el campo de cédula al estado de filtros
                                name="nombre_uc"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.nombre_uc)}
                            />

                            <Form.Control
                                type="text"
                                placeholder="Buscar por COD Programa"
                                value={filters.cod_uc} // Conecta el campo de cédula al estado de filtros
                                name="cod_uc"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.cod_uc)}
                            />
                           
                            </div>
                            <div className="d-flex mb-3 ">
                            <Form.Select
                                    name="externo"
                                    value={filters.externo}
                                    onChange={handleFilterChange}
                                    className={activeFilterClass(filters.externo)}
                                    style={{ width: 'auto' }}
                                    >
                                    <option value="">¿U.C externa?</option>
                                    <option value="true">Sí</option>
                                    <option value="false">No</option>
                            </Form.Select>
                            <Form.Select
                                name="status_pay"
                                value={filters.status_pay}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.status_pay)}
                                style={{ width: 'auto' }}
                                >
                                <option value="">Estado de pago</option>
                                <option value="1">No pagado (Rojo)</option>
                                <option value="2">Pago Inscripción Completo (Naranja)</option>
                                <option value="3">Pago Inscripción y Cuota Completo (Verde)</option>
                                <option value="4">Patrocinado (Azul)</option>
                                <option value="5">Exonerado (Rosado)</option>
                                </Form.Select>
                                <Form.Select
                                name="status_curso"
                                value={filters.status_curso}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.status_curso)}
                                style={{ width: 'auto' }}
                                >
                                <option value="">Estado de curso</option>
                                <option value="1">Inscrito (Naranja)</option>
                                <option value="2">Egresado/Certificado (Verde)</option>
                                <option value="3">Retirado (Rojo)</option>
                                </Form.Select>
                                <Form.Select
                                    name="es_patrocinado"
                                    value={filters.es_patrocinado}
                                    onChange={handleFilterChange}
                                    className={activeFilterClass(filters.es_patrocinado)}
                                    style={{ width: 'auto' }}
                                    >
                                    <option value="">¿Es patrocinado?</option>
                                    <option value="true">Sí</option>
                                    <option value="false">No</option>
                                    </Form.Select>
                                    <Form.Select
                                        name="tlf"
                                        value={filters.tlf}
                                        onChange={handleFilterChange}
                                        className={activeFilterClass(filters.tlf)}
                                        style={{ width: 'auto' }}
                                        >
                                        <option value="">¿Tiene Tlf?</option>
                                        <option value="true">Sí</option>
                                        <option value="false">No</option>
                                    </Form.Select>
                                                

                            </div>
                        <div className="d-flex mb-3 ">
                            
                        <Form.Select
                                name="nivel_instruccion_id"
                                value={filters.nivel_instruccion_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.nivel_instruccion_id)}
                            >
                                <option value="">Nivel de Instrucción</option>
                                {nivelInstruccionOptions?.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}

                            </Form.Select>

                            <Form.Select
                                name="genero_id"
                                value={filters.genero_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.genero_id)}
                            >
                                <option value="">Género</option>
                                {generoOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="estado_id"
                                value={filters.estado_id}
                                onChange={handleEstadoChange}
                                className={activeFilterClass(filters.estado_id)}
                            >
                                <option value="">Estado</option>
                                {estadoOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>

                            <Form.Select
                                    name="municipio"
                                    value={filters.municipio}
                                    onChange={(e) => setFilters({ ...filters, municipio: e.target.value })}
                                    className={activeFilterClass(filters.curso_descripcion)}
                                    
                                    disabled={!municipiosDisponibles.length}
                                    
                                    required
                                    
                                    >
                                    <option value="">Municipio</option>
                                    {municipiosDisponibles.map((municipio, index) => (
                                        <option key={index} value={municipio.municipio}>
                                        {municipio.municipio}
                                        </option>
                                    ))}
                                    </Form.Select>

                            <Form.Select
                                name="grupo"
                                value={filters.grupo}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.grupo)}
                            >
                                <option value="">Grupo</option>
                                {grupoOptions.map(option => (
                                    <option key={option.id} value={option.descripcion}>{option.descripcion}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="area_id"
                                value={filters.area_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.area_id)}
                            >
                                <option value="">Área</option>
                                {areaOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="centro_id"
                                value={filters.centro_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.centro_id)}
                            >
                                <option value="">Centro</option>
                                {centroOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="cohorte"
                                value={filters.cohorte}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.cohorte)}
                            >
                                <option value="">Cohorte</option>
                                {cohorteOptions.map(option => (
                                    <option key={option.id} value={option.descripcion}>{option.descripcion}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="periodo_id"
                                value={filters.periodo_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.periodo_id)}
                            >
                                <option value="">Periodo</option>
                                {periodoOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="unidad_id"
                                value={filters.unidad_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.unidad_id)}
                            >
                                <option value="">Unidad</option>
                                {unidadOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>

                            <Form.Select
                                name="grupo_prioritario_id"
                                value={filters.grupo_prioritario_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.grupo_prioritario_id)}
                            >
                                <option value="">Grupo Prioritario</option>
                                {grupoPrioritarioOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>
                            

                        </div>

                        <div className="d-flex mb-3 ">
                            <Form.Select
                                name="patrocinante_id"
                                value={filters.patrocinante_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.patrocinante_id)}
                            >
                                <option value="">Patrocinante 1</option>
                                {patrocinanteOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.nombre_patrocinante}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="patrocinante_id2"
                                value={filters.patrocinante_id2}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.patrocinante_id2)}
                            >
                                <option value="">Patrocinante 2</option>
                                {patrocinanteOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.nombre_patrocinante}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="patrocinante_id3"
                                value={filters.patrocinante_id3}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.patrocinante_id3)}
                            >
                                <option value="">Patrocinante 3</option>
                                {patrocinanteOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.nombre_patrocinante}</option>
                                ))}
                            </Form.Select>
                            <Form.Select
                                name="procedencia_id"
                                value={filters.procedencia_id}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.procedencia_id)}
                            >
                                <option value="">Procedencia</option>
                                {procedenciaOptions.map(option => (
                                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                                ))}
                            </Form.Select>

                        </div>
                        
                        <div className="d-flex mb-3 ">
                        <Form.Control
                                type="number"
                                placeholder="Edad mayor que"
                                value={filters.edad_mayor} // Conecta el campo de cédula al estado de filtros
                                name="edad_mayor"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.edad_mayor)}
                            />

                        <Form.Control
                                type="number"
                                placeholder="Edad menor que"
                                value={filters.edad_menor} // Conecta el campo de cédula al estado de filtros
                                name="edad_menor"
                                onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
                                className={activeFilterClass(filters.edad_menor)}
                            />  

                            </div>
                             {/* Leyenda de colores */}
                                <div className="status-legend d-flex justify-content-start mb-3">
                                    <span className="status-dot red"></span> No pagado (Rojo)
                                    <span className="status-dot orange ms-3"></span> Pago Inscripción Completo (Naranja)
                                    <span className="status-dot green ms-3"></span> Pago Inscripción y Cuota Completo(Verde)
                                    <span className="status-dot blue ms-3"></span> Patrocinado (Azul)
                                    <span className="status-dot pink ms-3"></span> Exonerado (Rosado)
                                    <span className="status-dot gray ms-3"></span> Nulo (gris)
                                </div>
                                <div className="status-legend d-flex justify-content-start mb-3">
                                    <span className="status-triangle not-finalized"></span> Inscrito (Naranja)
                                    <span className="status-triangle graduated ms-3"></span> Egresado/Certificado (Verde)
                                    <span className="status-triangle withdrawn ms-3"></span> Retirado (Rojo)
                                </div>

                             <div className="d-flex mb-3 ">
                          {/* Fecha con label en la misma línea */}
                                <div className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0">Fecha mayor que: </Form.Label>
                                    <Form.Control
                                    type="date"
                                    name="fecha_mayor"
                                    value={filters.fecha_mayor}
                                    onChange={handleFilterChange}
                                    style={{ width: 'auto' }}
                                    />
                                        </div>     

                                <div className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0">Fecha menor que: </Form.Label>
                                    <Form.Control
                                    type="date"
                                    name="fecha_menor"
                                    value={filters.fecha_menor}
                                    onChange={handleFilterChange}
                                    style={{ width: 'auto' }}
                                    />
                                        </div>        

                            </div>
                        
                       
                        <PaginationTable
                            data={datos}
                            itemsPerPage={itemsPerPage}
                            columns={columns}
                            renderItem={renderItem}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            totalPages={totalPages}  // <--- Añade esta línea si aún no está
                        />


                        

                        <ToastContainer />
                    </div>
                    
            </div>
            
            </div>
            {/* Gráfica  justo debajo de la tabla */}
           


        <motion.div
                initial={{ opacity: 1, height: "auto" }}
                animate={{ opacity: mostrarSoloTabla ? 0 : 1, height: mostrarSoloTabla ? 0 : "auto" }}
                transition={{ duration: 0.5 }}
            >
            {/* Orden pedido por José (24/09, punto 10): "Estado de Programas" arriba
                y "Participantes por Estado" al final. */}

            {/* 1. Estado de Programas */}
            <div className="col-lg-12 d-flex mt-2">
                <div className="chart-box" style={{ flex: '1 1 100%', maxWidth: '100%' }}>
                <h4 style={{ fontSize: '1.2rem' }}>Estado de Programas</h4>
                 {statistics?.totalInscritos !== undefined && (
                               <ResponsiveContainer width="100%" height={360}>
                               <BarChart data={estadoCurso} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                 <CartesianGrid strokeDasharray="3 3" />
                                 <XAxis dataKey="name" />
                                 <YAxis allowDecimals={false} />
                                 <Tooltip />
                                 <Bar dataKey="value" name="Inscritos">
                                   {/* Antes recorria estadoPago y pintaba con los colores de pagos. */}
                                   {(estadoCurso || []).map((entry, index) => (
                                     <Cell key={`cell-${index}`} fill={entry.color} />
                                   ))}
                                   <LabelList dataKey="value" position="top" />
                                 </Bar>
                               </BarChart>
                             </ResponsiveContainer>
                             )}
                </div>
            </div>

            {/* 2. Áreas y rango de edad */}
            <div className="col-lg-12 d-flex justify-content-between mt-3" style={{ gap: '20px' }}>
                <div className="chart-box" style={{ flex: '1 1 49%', maxWidth: '49%' }}>
                    <h4 style={{ fontSize: '1.2rem', color: 'gray' }}>Distribución por Áreas</h4>
                        <ResponsiveContainer width="100%" height={400}>
                        <PieChart>
                        <Pie
                            data={AreaGraphic}
                            cx="50%"
                            cy="45%"
                            outerRadius={140}
                            fill="#8884d8"
                            dataKey="value"
                            label={({ percent }) => ` ${(percent * 100).toFixed(0)}%`}
                        >
                            {AreaGraphic.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend/>
                        </PieChart>
                        </ResponsiveContainer>
                </div>

                <div className="chart-box" style={{ flex: '1 1 49%', maxWidth: '49%' }}>
                <h4 style={{ fontSize: '1.2rem', color: 'gray' }}>Distribución por Rango de Edad</h4>
                    <ResponsiveContainer width="100%" height={400}>
                        <PieChart>
                            <Pie
                                data={rangoEdades.filter((r) => r.value > 0)}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="45%"
                                outerRadius={130}
                                fill="#82ca9d"
                                label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
                            >
                                {rangoEdades.filter((r) => r.value > 0).map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS_EDAD[index % COLORS_EDAD.length]} />
                                ))}
                            </Pie>
                            {/* El valor es una cantidad de personas, no un porcentaje. */}
                            <Tooltip formatter={(value) => `${value} personas`} />
                            <Legend layout="horizontal" verticalAlign="bottom" align="center" wrapperStyle={{ fontSize: '14px' }} />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* 3. Punto 11: grupo prioritario, período, procedencia, unidad y cohorte.
                Contenedores flex y no .row/.col: EditVoluntariados.css redefine .row
                para toda la aplicación y rompe la grilla de Bootstrap aquí. */}
            <div className="d-flex flex-wrap mt-3" style={{ gap: '20px' }}>
                <div style={{ flex: '1 1 calc(50% - 10px)', minWidth: 0 }}><GraficaBarras titulo="Por Grupo Prioritario" datos={statistics?.porGrupoPrioritario} color="#8884d8" /></div>
                <div style={{ flex: '1 1 calc(50% - 10px)', minWidth: 0 }}><GraficaBarras titulo="Por Período" datos={statistics?.porPeriodo} color="#82ca9d" /></div>
                <div style={{ flex: '1 1 calc(50% - 10px)', minWidth: 0 }}><GraficaBarras titulo="Por Procedencia" datos={statistics?.porProcedencia} color="#ffc658" /></div>
                <div style={{ flex: '1 1 calc(50% - 10px)', minWidth: 0 }}><GraficaBarras titulo="Por Unidad" datos={statistics?.porUnidad} color="#ff7300" /></div>
                <div style={{ flex: '1 1 100%', minWidth: 0 }}><GraficaBarras titulo="Por Cohorte" datos={statistics?.porCohorte} color="#00C49F" /></div>
            </div>

            {/* 4. Punto 12: personas por curso */}
            <div className="d-flex mt-3">
                <div style={{ flex: '1 1 100%', minWidth: 0 }}>
                    <GraficaBarras
                        titulo="Personas por Curso"
                        nota="Se ajusta a los filtros de arriba: elija cohorte, período o centro para ver cuántas personas hay en cada curso."
                        datos={statistics?.porCurso}
                        maximo={25}
                        color="#6f42c1"
                    />
                </div>
            </div>

            {/* 5. Al final: participantes por estado */}
            <div className="d-flex mt-3">
                <div style={{ flex: '1 1 100%', minWidth: 0 }}>
                <div className="chart-box" style={{ width: '100%' }}>
                <h4 style={{ fontSize: '1.2rem' }}>Cantidad de Participantes por Estado</h4>
                    {estadoOptions.length > 0 && participantesPorEstadoData.length > 0 && (
                       <ResponsiveContainer width="100%" height={400}>
                        <BarChart data={participantesPorEstadoData} margin={{ top: 40, right: 30, left: 0, bottom: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis allowDecimals={false} />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="count" fill="#8884d8" name="Participantes">
                                <LabelList dataKey="count" position="top" />
                            </Bar>
                        </BarChart>
                   </ResponsiveContainer>
                    )}
                </div>
                </div>
            </div>

                    {/* Modal de confirmación */}
                    <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)} centered>
                    <Modal.Header closeButton>
                    <Modal.Title>Confirmar impresión</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    ¿Está seguro que desea imprimir la información? Esto generará un archivo descargable en formato Excel.
                    </Modal.Body>
                    <Modal.Footer>
                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={() => setShowModalInfo(false)}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handlePrint}>
                            Imprimir
                        </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </motion.div>


             
                        

    </div>
                    

                );
};

export default ShowIndicadores;
